/**
 * Casino Account manage scope (Create / upcoming Delete) — FE copy.
 * Keep in sync with services/ms-auth/src/API/lib/casinoAccountScope.ts
 * and onlyCasinoGroups helpers (shortName / Only_* prefix match).
 */

const ONLY_CASINO_GROUP_PREFIX = 'Only_';

function normalizeCasinoGroupCode(raw: unknown): string {
  return String(raw ?? '').trim().toUpperCase();
}

function extractOnlyCasinoCodesFromGroups(groups: string[] = []): string[] {
  const out: string[] = [];
  for (const g of groups || []) {
    if (typeof g !== 'string' || !g.startsWith(ONLY_CASINO_GROUP_PREFIX)) continue;
    const code = normalizeCasinoGroupCode(g.slice(ONLY_CASINO_GROUP_PREFIX.length));
    if (code) out.push(code);
  }
  return Array.from(new Set(out));
}

function casinoMatchesOnlyCodes(
  casino: { shortName?: string } | null | undefined,
  codes: string[]
): boolean {
  if (!casino || !codes.length) return false;
  const set = new Set(codes.map((c) => normalizeCasinoGroupCode(c)).filter(Boolean));
  const sn = normalizeCasinoGroupCode(casino.shortName);
  return Boolean(sn) && set.has(sn);
}

export type CasinoAccountManageScope =
  | { scoped: false }
  | { scoped: true; onlyCodes: string[] };

export function resolveCasinoAccountManageScope(
  groups: string[] = []
): CasinoAccountManageScope {
  const onlyCodes = extractOnlyCasinoCodesFromGroups(groups);
  if (onlyCodes.length === 0) return { scoped: false };
  return { scoped: true, onlyCodes };
}

/** Filter picker options: unscoped → all; Only_* → matching shortNames only. */
export function filterCasinosForAccountManage<T extends { shortName?: string }>(
  casinos: T[],
  groups: string[] = []
): T[] {
  const list = Array.isArray(casinos) ? casinos : [];
  const scope = resolveCasinoAccountManageScope(groups);
  if (!scope.scoped) return list.slice();
  return list.filter((c) => casinoMatchesOnlyCodes(c, scope.onlyCodes));
}
